/* FRANK14 · bold — la scheda del capo.
   Quattro cose sole, tutte al servizio del comprare:
     1. la lente: col cursore sopra, la fotografia si ingrandisce dove guardi;
     2. il contatore 01/05 mentre si scorre la striscia sul telefono;
     3. la barra d'oro che sale dal fondo quando il bottone vero esce di scena;
     4. il prezzo e lo stato «esaurito» tenuti d'accordo col bottone vero, che è
        Dawn ad aggiornare quando si cambia taglia.
   Il resto (varianti, carrello) resta a product-info.js e product-form.js. */
(function () {
  var scheda = document.querySelector('product-info.pr');
  if (!scheda) return;
  var pigro = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. la lente ---------- */
  if (!pigro && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    [].forEach.call(scheda.querySelectorAll('[data-pr-figura]'), function (figura) {
      var img = figura.querySelector('img');
      if (!img) return;
      figura.addEventListener('mouseenter', function () { figura.classList.add('con-lente'); });
      figura.addEventListener('mouseleave', function () { figura.classList.remove('con-lente'); });
      figura.addEventListener('mousemove', function (e) {
        var r = figura.getBoundingClientRect();
        figura.style.setProperty('--zx', (((e.clientX - r.left) / r.width) * 100).toFixed(2) + '%');
        figura.style.setProperty('--zy', (((e.clientY - r.top) / r.height) * 100).toFixed(2) + '%');
      });
    });
  }

  /* ---------- 2. il contatore della striscia ---------- */
  (function () {
    var striscia = scheda.querySelector('[data-pr-foto]');
    var conta = scheda.querySelector('[data-pr-conta]');
    if (!striscia || !conta) return;
    var numero = conta.querySelector('b');
    var figure = striscia.querySelectorAll('[data-pr-figura]');
    var fermo;
    striscia.addEventListener('scroll', function () {
      window.clearTimeout(fermo);
      fermo = window.setTimeout(function () {
        var centro = striscia.scrollLeft + striscia.clientWidth / 2;
        var quale = 1;
        [].forEach.call(figure, function (f, i) {
          if (f.offsetLeft <= centro && f.offsetLeft + f.offsetWidth > centro) quale = i + 1;
        });
        numero.textContent = quale < 10 ? '0' + quale : String(quale);
      }, 80);
    }, { passive: true });
  })();

  /* ---------- 3. la barra d'oro ---------- */
  var barra = scheda.querySelector('[data-pr-barra]');
  var bottone = scheda.querySelector('.pr__bottone');
  if (barra && bottone) {
    /* La barra sale quando il bottone vero è rimasto SOPRA, cioè quando ci sei
       passato davanti — non quando semplicemente non si vede.
       (Con IntersectionObserver non funzionava: sul telefono il bottone è già
       fuori schermo in basso appena apri la pagina, quindi l'osservatore
       scattava una volta sola e non si svegliava più.) */
    var inCoda = false;
    function guardaBarra() {
      inCoda = false;
      var r = bottone.getBoundingClientRect();
      var passato = r.bottom < 10;
      barra.classList.toggle('si-vede', passato);
      barra.setAttribute('aria-hidden', passato ? 'false' : 'true');
      var bottoneBarra = barra.querySelector('.pr__barra-bottone');
      if (bottoneBarra) bottoneBarra.tabIndex = passato ? 0 : -1;
    }
    function chiediBarra() {
      if (inCoda) return;
      inCoda = true;
      window.requestAnimationFrame(guardaBarra);
    }
    window.addEventListener('scroll', chiediBarra, { passive: true });
    window.addEventListener('resize', chiediBarra, { passive: true });
    if (window.__lenis && window.__lenis.on) window.__lenis.on('scroll', chiediBarra);
    guardaBarra();
  }

  /* ---------- 4. prezzo e «esaurito» d'accordo col bottone ---------- */
  (function () {
    var forma = scheda.querySelector('product-form');
    var prezzoBarra = scheda.querySelector('[data-pr-barra-prezzo]');
    if (!bottone) return;

    /* Dawn, quando cambi variante, riscrive il testo del bottone con la sua
       stringa («Aggiungi al carrello»): se il bottone è acceso si rimette il
       nostro («Mettilo nella busta», da data-testo-busta). Da spento il testo
       resta quello di Dawn («Esaurito» / «Non disponibile»), che è giusto. */
    var testoBusta = bottone.getAttribute('data-testo-busta');
    var nodoTesto = bottone.querySelector('.pr__bottone-testo');
    function testoGiusto() {
      if (!testoBusta || !nodoTesto || bottone.hasAttribute('disabled')) return;
      if (nodoTesto.textContent.trim() !== testoBusta) nodoTesto.textContent = testoBusta;
    }

    function allinea() {
      testoGiusto();
      var spento = bottone.hasAttribute('disabled');
      if (forma) forma.classList.toggle('is-esaurito', spento);
      /* «Paga ora» e «Paga in 3 rate» seguono il bottone principale */
      var veloci = scheda.querySelector('[data-pr-veloci]');
      if (veloci) {
        veloci.style.display = spento ? 'none' : '';
        [].forEach.call(veloci.querySelectorAll('[data-compra]'), function (b) {
          if (!b.classList.contains('sta-caricando')) b.disabled = spento;
        });
      }
      var bottoneBarra = barra ? barra.querySelector('.pr__barra-bottone') : null;
      if (bottoneBarra) {
        if (spento) bottoneBarra.setAttribute('disabled', ''); else bottoneBarra.removeAttribute('disabled');
      }
      /* la rata del bottone «Paga in 3 rate da €X» segue la variante scelta */
      var rataNuova = scheda.querySelector('[data-pr-rata]');
      var rataBottone = scheda.querySelector('.pr__tre b');
      if (rataNuova && rataBottone) {
        var rata = rataNuova.textContent.trim();
        if (rata && rataBottone.textContent.trim() !== rata) rataBottone.textContent = rata;
      }
      var cifra = scheda.querySelector('.pr__cifra');
      if (cifra && prezzoBarra) {
        var testo = cifra.textContent.trim();
        if (prezzoBarra.textContent.trim() !== testo) prezzoBarra.textContent = testo;
      }
    }

    allinea();
    /* Dawn riscrive prezzo e bottone quando si cambia taglia: si guardano LORO
       DUE, non tutta la scheda. Osservare tutto significava osservare anche la
       barra che questa stessa funzione riscrive: il ciclo si mordeva la coda e
       la pagina non finiva più di caricare. */
    new MutationObserver(allinea).observe(bottone, { attributes: true, attributeFilter: ['disabled'] });
    /* il testo cambia anche senza che cambi «disabled» (da una taglia disponibile
       a un'altra): si guarda il solo testo; testoGiusto non riscrive se è già giusto */
    if (nodoTesto) new MutationObserver(testoGiusto).observe(nodoTesto, { childList: true, characterData: true, subtree: true });
    var nodoPrezzo = scheda.querySelector('.pr__prezzo');
    if (nodoPrezzo) {
      new MutationObserver(allinea).observe(nodoPrezzo, { childList: true, subtree: true, characterData: true });
    }
  })();
})();
